import { render } from "./AddToHomeScreen.vue?vue&type=template&id=ef57c076"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maxime/Documents/Projects/Ombrage/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__